import { render, staticRenderFns } from "./InspectionTemplateManage.vue?vue&type=template&id=65c85a6a&scoped=true"
import script from "./InspectionTemplateManage.vue?vue&type=script&lang=js"
export * from "./InspectionTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./InspectionTemplateManage.vue?vue&type=style&index=0&id=65c85a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c85a6a",
  null
  
)

export default component.exports